import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PostHogProvider } from '@posthog/react';
import * as Sentry from '@sentry/react';
import { RouterProvider } from '@ui/app-router';
import { env } from '@ui/environment';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { PostHogRouterSync } from './app/components/PostHogRouterSync';
import router from './app/router';
// Disable sending sentry tracing information in localhost development
if (env.PUBLIC_USE_SENTRY && env.PUBLIC_SENTRY_DSN && env.PUBLIC_ENV !== 'local') {
    // Our domain list so we can private tracing data just to them
    // must be the same as our api Sentry config
    const targets = [
        /^https?:\/\/api\.zephyr-cloud\.io/i,
        /^https?:\/\/api-dev\.zephyr-cloud\.io/i,
        /^https?:\/\/api-prerelease\.zephyr-cloud\.io/i
    ];
    Sentry.init({
        dsn: env.PUBLIC_SENTRY_DSN,
        environment: env.PUBLIC_ENV,
        release: env.PUBLIC_SENTRY_RELEASE,
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        // Our public domains
        tracePropagationTargets: targets,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                networkDetailAllowUrls: targets,
                maskAllText: false,
                maskAllInputs: true,
                blockAllMedia: true,
                mask: [
                    '.sentry-hide'
                ]
            }),
            Sentry.tanstackRouterBrowserTracingIntegration(router),
            Sentry.consoleLoggingIntegration({
                levels: [
                    'error'
                ]
            })
        ],
        ignoreErrors: [
            // Thrown when link scanners (mainly Outlook 365) scan our links
            /^Non-Error promise rejection captured with value: Object Not Found Matching Id:/i
        ]
    });
}
const rootElement = document.getElementById('root');
if (!rootElement.innerHTML) {
    const posthogEnabled = env.PUBLIC_USE_POSTHOG && !!env.PUBLIC_POSTHOG_KEY;
    const posthogOptions = {
        api_host: env.PUBLIC_POSTHOG_HOST,
        ui_host: 'https://us.posthog.com',
        defaults: '2026-01-30',
        autocapture: true,
        capture_pageview: false,
        capture_pageleave: true,
        capture_dead_clicks: true,
        rageclick: true,
        // Avoid collecting form field values by default.
        mask_all_text: false,
        mask_all_element_attributes: true
    };
    const root = ReactDOM.createRoot(rootElement);
    root.render(/*#__PURE__*/ _jsx(StrictMode, {
        children: posthogEnabled ? /*#__PURE__*/ _jsxs(PostHogProvider, {
            apiKey: env.PUBLIC_POSTHOG_KEY,
            options: posthogOptions,
            children: [
                /*#__PURE__*/ _jsx(PostHogRouterSync, {
                    router: router
                }),
                /*#__PURE__*/ _jsx(RouterProvider, {
                    router: router
                })
            ]
        }) : /*#__PURE__*/ _jsx(RouterProvider, {
            router: router
        })
    }));
}
